class HeaderSearch extends HTMLElement {
  constructor() {
    super();
    this.toggleBtn = this.querySelector('.header-search-toggle');
    this.dropdown = this.querySelector('.prima-header-search-bar');
    this.input = this.querySelector('.prima-sample-search-input, input[name="q"]');
    this.clearCloseBtn = this.querySelector('.prima-sample-clear-close-btn');

    if (this.toggleBtn) {
      this.toggleBtn.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();
        this.toggle();
      });
    }

    if (this.clearCloseBtn) {
      this.clearCloseBtn.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();

        const input = this.querySelector('.prima-sample-search-input, input[name="q"], input[type="search"], input[type="text"]');
        if (input && input.value && input.value.trim().length > 0) {
          input.value = '';
          input.focus();
          input.dispatchEvent(new Event('input', { bubbles: true }));
          input.dispatchEvent(new Event('change', { bubbles: true }));
        } else {
          this.close();
        }
      });
    }

    // Close on Escape key
    this.addEventListener('keyup', (event) => {
      if (event.code && event.code.toUpperCase() === 'ESCAPE') {
        this.close();
      }
    });
  }

  isOpen() {
    return this.dropdown && this.dropdown.classList.contains('is-open');
  }

  toggle() {
    this.isOpen() ? this.close() : this.open();
  }

  open() {
    if (!this.dropdown) return;
    this.dropdown.removeAttribute('hidden');
    void this.dropdown.offsetHeight; // force reflow for smooth transition
    this.dropdown.classList.add('is-open');
    if (this.toggleBtn) {
      this.toggleBtn.setAttribute('aria-expanded', 'true');
    }

    const input = this.querySelector('.prima-sample-search-input, input[name="q"], input[type="search"], input[type="text"]');
    if (input) {
      input.focus();
    }
  }

  close() {
    if (!this.dropdown) return;
    this.dropdown.classList.remove('is-open');
    if (this.toggleBtn) {
      this.toggleBtn.setAttribute('aria-expanded', 'false');
    }
  }
}

customElements.define('header-search', HeaderSearch);

class DetailsModal extends HTMLElement {
  constructor() {
    super();
    this.detailsContainer = this.querySelector('details');
    this.summaryToggle = this.querySelector('summary');

    if (this.detailsContainer) {
      this.detailsContainer.addEventListener('keyup', (event) => event.code.toUpperCase() === 'ESCAPE' && this.close());
    }
    if (this.summaryToggle) {
      this.summaryToggle.addEventListener('click', this.onSummaryClick.bind(this));
      this.summaryToggle.setAttribute('role', 'button');
    }

    const closeButtons = this.querySelectorAll('.modal__close-button, .modal__toggle-close, [data-modal-close]');
    closeButtons.forEach((button) => {
      button.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();
        this.close();
      });
    });
  }

  isOpen() {
    return this.detailsContainer && this.detailsContainer.hasAttribute('open');
  }

  onSummaryClick(event) {
    event.preventDefault();
    this.isOpen() ? this.close() : this.open(event);
  }

  onBodyClick(event) {
    if (!this.contains(event.target)) {
      this.close(false);
    }
  }

  open(event) {
    if (!this.detailsContainer) return;
    this.onBodyClickEvent = this.onBodyClickEvent || this.onBodyClick.bind(this);
    this.detailsContainer.setAttribute('open', true);
    
    setTimeout(() => {
      document.addEventListener('click', this.onBodyClickEvent);
    }, 0);

    const input = this.detailsContainer.querySelector('input:not([type="hidden"])');
    if (input) {
      input.focus();
    }
  }

  close(focusToggle = true) {
    if (focusToggle && this.summaryToggle) {
      this.summaryToggle.focus();
    }
    if (this.detailsContainer) {
      this.detailsContainer.removeAttribute('open');
    }
    document.removeEventListener('click', this.onBodyClickEvent);
  }
}

customElements.define('details-modal', DetailsModal);
